import styles from './item.module.css'

const ModuleWrapper = props =>(
    <div className={`${styles.timelineBorder} d-flex border-left align-items-start  pb-5`}>
        <span className={`d-inline-block position-relative bg-white rounded-circle border ${styles.timelineCircle}`}></span>
        {props.children}
    </div>
);

export default ModuleWrapper